{
  "ResourceRowGallery": {
    "failedToLoad": "加载 Pin 失败",
    "empty": "暂无 Pin",
    "addContactPins": "添加 Pin"
  },
  "TransferResourceDialog": {
    "title": "转移到工作区",
    "description_one": "将 {{name}} 移动到另一个工作区。",
    "description_other": "将 {{count}} 个资源移动到另一个工作区。",
    "fieldWorkspace": "目标工作区",
    "success_one": "资源已转移",
    "success_other": "已转移 {{count}} 个资源"
  }
}
